import React from 'react'
import { SxProps, Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { routeMap } from '@core/constants/routes'
import { queryKeys as foldersQueryKeys } from '@core/folders/folders-api'
import { useAppSelector } from '@core/store'
import { useGetDefaultAuthorRoute } from '@pages/author-v2/author-v2-hooks'
import { useQueryClient } from '@tanstack/react-query'

const tab: SxProps = {
  color: 'other.downriver',
  height: 56,
  flexShrink: 0,
}

const FineTuneTabs = (props: { onClear: () => void }) => {
  const { t } = useTranslation('common')
  const location = useLocation()
  const queryClient = useQueryClient()
  const authorRoute = useGetDefaultAuthorRoute()

  const value = React.useMemo(() => {
    if (location.pathname.startsWith(routeMap.MY_FOLDERS_ROUTE)) {
      return routeMap.MY_FOLDERS_ROUTE
    }

    if (location.pathname.startsWith(routeMap.USERS_ROUTE)) {
      return routeMap.USERS_ROUTE
    }

    if (location.pathname.startsWith('/internal/')) {
      return false
    }

    return routeMap.AUTHOR_ROUTE
  }, [location.pathname])

  const user = useAppSelector((state) => state.main.user)

  if (!user || !user.role) {
    return null
  }

  return (
    <Tabs
      sx={(theme) => ({
        m: {
          sm: theme.spacing(0, 'auto', 0, 5),
          md: theme.spacing(0, 'auto', 0, 7),
          lg: theme.spacing(0, 'auto', 0, 10),
        },
      })}
      variant="standard"
      value={value}
      aria-label="nav tabs"
    >
      <Tab
        component={Link}
        sx={tab}
        id="nav-tab-1"
        label={t('nav.author')}
        to={authorRoute}
        onClick={props.onClear}
        value={routeMap.AUTHOR_ROUTE}
        aria-controls="nav-tabpanel-1"
      />

      <Tab
        component={Link}
        sx={tab}
        id="nav-tab-3"
        label={t('nav.my_folders')}
        to={routeMap.MY_FOLDERS_ROUTE}
        value={routeMap.MY_FOLDERS_ROUTE}
        onClick={() => {
          queryClient.invalidateQueries({
            queryKey: foldersQueryKeys.all,
          })
        }}
        aria-controls="nav-tabpanel-3"
      />

      {user.role === 'Admin' && (
        <Tab
          component={Link}
          sx={tab}
          id="nav-tab-4"
          label={t('nav.users')}
          to={routeMap.USERS_ROUTE}
          value={routeMap.USERS_ROUTE}
          aria-controls="nav-tabpanel-4"
        />
      )}
    </Tabs>
  )
}

export default FineTuneTabs
